var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c(
        "q-modal",
        {
          attrs: { "content-css": { minWidth: "70vw" } },
          model: {
            value: _vm.modalEditar,
            callback: function($$v) {
              _vm.modalEditar = $$v
            },
            expression: "modalEditar"
          }
        },
        [
          _c("q-card-main", [
            _c("div", { staticClass: "q-card gvn-cabecalho mrg-b-10" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("strong", [_vm._v("Nº do Processo / Ano: ")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .aberturaProcesso.numProcesso
                        ) +
                        "/" +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .aberturaProcesso.anoProcesso
                        ) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("strong", [_vm._v("Nº Protocolo: ")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .aberturaProcesso.numProtocolo
                        ) +
                        "\n          "
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("strong", [_vm._v("Rota / Sequência: ")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .aberturaProcesso.roteiro.numRota
                        ) +
                        "\n            /" +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .numSequencia
                        ) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("strong", [_vm._v("Tipo de Processo: ")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .aberturaProcesso.tipoProcesso.desTipoProcesso
                        ) +
                        "\n          "
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("strong", [_vm._v("Assunto: ")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .aberturaProcesso.subassunto.assunto.desAssunto
                        ) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("strong", [_vm._v("Requerente: ")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .aberturaProcesso.requerente.nomRequerente
                        ) +
                        "\n          "
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("strong", [_vm._v("Subassunto: ")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .aberturaProcesso.subassunto.desSubassunto
                        ) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _c("br"),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [_c("strong", [_vm._v("Local de origem ")])]
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6" },
                  [
                    _c("strong", [_vm._v("Órgão: ")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .setor.unidade.orgao.desOrgao
                        ) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("strong", [_vm._v("Unidade: ")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .setor.unidade.desUnidade
                        ) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("strong", [_vm._v("Setor: ")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          this.newPaginaStatusMovimentacao.movimentacaoProcesso
                            .setor.desSetor
                        ) +
                        "\n          "
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "titulo-card" }, [
              _vm._v("\n        Histórico de movimentação\n      ")
            ]),
            _c(
              "table",
              {
                staticClass: "col-md-12",
                attrs: { cellspacing: "0", cellpadding: "0" }
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "5%" } },
                      [_vm._v("Mov.")]
                    ),
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "15%" } },
                      [_vm._v("Responsável")]
                    ),
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "20%" } },
                      [_vm._v("Órgão")]
                    ),
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "20%" } },
                      [_vm._v("Unidade")]
                    ),
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "20%" } },
                      [_vm._v("Setor")]
                    ),
                    _c("th", {
                      staticClass: "text-right",
                      attrs: { width: "5%" }
                    }),
                    _c("th", {
                      staticClass: "text-right",
                      attrs: { width: "5%" }
                    })
                  ])
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.arrayMovimentos, function(mov) {
                    return _c("tr", { key: mov.a }, [
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(mov.numSequencia) +
                            "\n            "
                        )
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              mov.responsavelMovimento.usuario.nomUsuario
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(mov.setor.unidade.orgao.desOrgao) +
                            "\n            "
                        )
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(mov.setor.unidade.desUnidade) +
                            "\n            "
                        )
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(mov.setor.desSetor) +
                            "\n            "
                        )
                      ]),
                      _c(
                        "td",
                        { staticClass: "text-right" },
                        [
                          _c("q-tooltip", [_vm._v("Visualizar")]),
                          _c(
                            "button",
                            {
                              staticClass: "btn-grid-secundario",
                              on: {
                                click: function($event) {
                                  _vm.visualizarMovimento(mov.codMovimentacao)
                                }
                              }
                            },
                            [_c("i", { staticClass: "q-icon  fas fa-search" })]
                          )
                        ],
                        1
                      ),
                      _c(
                        "td",
                        [
                          _c("q-tooltip", [
                            _vm._v("Imprimir comprovante de movimentação")
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "btn-grid-preto",
                              on: {
                                click: function($event) {
                                  _vm.imprimirMovimento(mov.codMovimentacao)
                                }
                              }
                            },
                            [_c("i", { staticClass: "q-icon  fas fa-print" })]
                          )
                        ],
                        1
                      )
                    ])
                  })
                )
              ]
            ),
            _c("br"),
            _c("div", { staticClass: "row center" }, [
              _c("div", { staticClass: "titulo-notificacao" }, [
                _c("i", { staticClass: "titulo-icone fas fa-exclamation" }),
                _vm._v(
                  "\n          Este processo não pode ser editado pois foi feito mais de uma movimentação.\n        "
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "col-sm-6 text-right" },
              [
                _c("q-btn", {
                  attrs: {
                    id: "Fechar",
                    name: "Fechar",
                    color: "tertiary",
                    label: "Fechar"
                  },
                  on: {
                    click: function($event) {
                      _vm.modalEditar = false
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "g-pesquisa",
        {
          ref: "refResultadoPesquisaAberturaProcesso",
          attrs: {
            id: "refResultadoPesquisaAberturaProcesso",
            name: "refResultadoPesquisaAberturaProcesso",
            filtroAdicional: _vm.getFiltroPesquisa,
            limparFiltroLocal: _vm.limparFiltro,
            colunasPropriedade: _vm.colunasAberturaProcessoDataTable,
            apiPesquisa: _vm.apiaberturaProcesso,
            operacoes: _vm.operacoes,
            exibirColunaOperacoes: _vm.exibirColunaOperacoes,
            operacoesQFab: _vm.operacoesQFab,
            exibirColunaOperacoesQFab: true,
            elementosPorPagina: _vm.elementosPorPagina,
            novo: _vm.abrirPaginaAberturaProcessoCadastrar,
            imprimir: _vm.imprimir,
            showTermoPesquisa: false,
            showBuscaAvancadaAberta: true,
            carregamentoInicial: false,
            showBotaoNovo: _vm.permissaoPerfil.incluir
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-2 col-xs-2" },
              [
                _c("g-input", {
                  ref: "refNumProcessoInicial",
                  attrs: {
                    id: "refNumProcessoInicial",
                    name: "refNumProcessoInicial",
                    validacao: "Number",
                    mascara: "numero",
                    tamanho: 10,
                    etiqueta: "Nº Processo Inicial",
                    foco: false
                  },
                  on: { input: _vm.alterouNumProcesso },
                  model: {
                    value: _vm.aberturaProcesso.numProcesso,
                    callback: function($$v) {
                      _vm.$set(_vm.aberturaProcesso, "numProcesso", $$v)
                    },
                    expression: "aberturaProcesso.numProcesso"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-2 col-xs-2" },
              [
                _c("g-input", {
                  ref: "refNumProcessoFinal",
                  attrs: {
                    id: "refNumProcessoFinal",
                    name: "refNumProcessoFinal",
                    validacao: "Number",
                    mascara: "numero",
                    tamanho: 10,
                    etiqueta: "Nº Processo Final",
                    foco: false
                  },
                  model: {
                    value: _vm.numProcessoFinal,
                    callback: function($$v) {
                      _vm.numProcessoFinal = $$v
                    },
                    expression: "numProcessoFinal"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "col-sm-2 col-xs-2",
                staticStyle: { "padding-right": "30px" }
              },
              [
                _c("g-dateInput", {
                  ref: "refDatAtualizacao",
                  attrs: {
                    id: "refDatAtualizacao",
                    name: "refDatAtualizacao",
                    etiqueta: "Data Atualização Inicial",
                    desabilitar: false,
                    somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                    dataMax: new Date()
                  },
                  model: {
                    value: _vm.datAtualizacao,
                    callback: function($$v) {
                      _vm.datAtualizacao = $$v
                    },
                    expression: "datAtualizacao"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "col-sm-2 col-xs-2",
                staticStyle: { "padding-right": "30px" }
              },
              [
                _c("g-dateInput", {
                  ref: "refDatAtualizacaoFinal",
                  attrs: {
                    id: "refDatAtualizacaoFinal",
                    name: "refDatAtualizacaoFinal",
                    etiqueta: "Data Atualização Final",
                    desabilitar: false,
                    somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                    dataMax: new Date()
                  },
                  model: {
                    value: _vm.datAtualizacaoFinal,
                    callback: function($$v) {
                      _vm.datAtualizacaoFinal = $$v
                    },
                    expression: "datAtualizacaoFinal"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-4 col-xs-4" },
              [
                _c("q-select", {
                  staticStyle: { margin: "0 10px 0 0" },
                  attrs: {
                    multiple: "",
                    chips: "",
                    "stack-label": "Status Atual",
                    color: "primary",
                    options: _vm.statusProcessoArray
                  },
                  on: { input: _vm.alterouStatusProcesso },
                  model: {
                    value: _vm.StatusProcesso,
                    callback: function($$v) {
                      _vm.StatusProcesso = $$v
                    },
                    expression: "StatusProcesso"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-6 col-xs-6" },
              [
                _c("g-autocomplete", {
                  ref: "refAssunto",
                  attrs: {
                    id: "refAssunto",
                    name: "refAssunto",
                    etiqueta: "Assunto",
                    valor: "codAssunto",
                    descricaoPrimaria: "desAssunto",
                    foco: false,
                    api: _vm.apiAssunto
                  },
                  model: {
                    value: _vm.aberturaProcesso.codAssunto,
                    callback: function($$v) {
                      _vm.$set(_vm.aberturaProcesso, "codAssunto", $$v)
                    },
                    expression: "aberturaProcesso.codAssunto"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-6 col-xs-6" },
              [
                _c("g-autocomplete", {
                  ref: "refSubAssunto",
                  attrs: {
                    id: "refSubAssunto",
                    name: "refSubAssunto",
                    etiqueta: "Subassunto",
                    valor: "codSubassunto",
                    descricaoPrimaria: "desSubassunto",
                    api:
                      _vm.aberturaProcesso.codAssunto !== ""
                        ? _vm.apiSubAssuntoTermo
                        : _vm.apiSubAssunto,
                    foco: false,
                    filtroAdicional: _vm.getFiltroSubassunto
                  },
                  model: {
                    value: _vm.aberturaProcesso.codSubassunto,
                    callback: function($$v) {
                      _vm.$set(_vm.aberturaProcesso, "codSubassunto", $$v)
                    },
                    expression: "aberturaProcesso.codSubassunto"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-6 col-xs-6" },
              [
                _c("g-autocomplete", {
                  ref: "refRequerente",
                  attrs: {
                    id: "refRequerente",
                    name: "refRequerente",
                    etiqueta: "Requerente",
                    valor: "codRequerente",
                    foco: false,
                    descricaoPrimaria: "nomeDataNascimentoDocumento",
                    desabilitar: _vm.paginaStatus.desabilitarEdicao,
                    api: _vm.apiRequerente,
                    filtroAdicional: _vm.getFiltroRequerente
                  },
                  model: {
                    value: _vm.aberturaProcesso.requerente.codRequerente,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.aberturaProcesso.requerente,
                        "codRequerente",
                        $$v
                      )
                    },
                    expression: "aberturaProcesso.requerente.codRequerente"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-3 col-xs-3" },
              [
                _c("g-autocomplete", {
                  ref: "refSituacao",
                  attrs: {
                    id: "refSituacao",
                    name: "refSituacao",
                    valor: "desSituacao",
                    etiqueta: "Situação",
                    descricaoPrimaria: "desSituacao",
                    api: _vm.apiSituacao,
                    foco: false,
                    desabilitar: _vm.paginaStatus.desabilitarEdicao
                  },
                  model: {
                    value: _vm.desSituacao,
                    callback: function($$v) {
                      _vm.desSituacao = $$v
                    },
                    expression: "desSituacao"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-3 col-xs-3" },
              [
                _c("g-input", {
                  ref: "refNotaFiscal",
                  attrs: {
                    id: "refNotaFiscal",
                    name: "refNotaFiscal",
                    validacao: "Number",
                    tamanho: 40,
                    etiqueta: "Nota Fiscal",
                    foco: false
                  },
                  model: {
                    value: _vm.aberturaProcesso.txtNotaFiscal,
                    callback: function($$v) {
                      _vm.$set(_vm.aberturaProcesso, "txtNotaFiscal", $$v)
                    },
                    expression: "aberturaProcesso.txtNotaFiscal"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-2 col-xs-2" },
              [
                _c("q-checkbox", {
                  attrs: { color: "primary", label: "Pendente de confirmação" },
                  model: {
                    value: _vm.indPendenteConfirmacao,
                    callback: function($$v) {
                      _vm.indPendenteConfirmacao = $$v
                    },
                    expression: "indPendenteConfirmacao"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-2 col-xs-2" },
              [
                _c("q-checkbox", {
                  attrs: { color: "primary", label: "Processo com Pendência" },
                  model: {
                    value: _vm.indPendencia,
                    callback: function($$v) {
                      _vm.indPendencia = $$v
                    },
                    expression: "indPendencia"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-2 col-xs-2" },
              [
                _c("q-checkbox", {
                  attrs: {
                    color: "primary",
                    label: "Retorno Pendência Externa"
                  },
                  model: {
                    value: _vm.indPendenciaComAnexo,
                    callback: function($$v) {
                      _vm.indPendenciaComAnexo = $$v
                    },
                    expression: "indPendenciaComAnexo"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-2 col-xs-2" },
              [
                _c("q-checkbox", {
                  attrs: { color: "primary", label: "Processo Estornado" },
                  model: {
                    value: _vm.indEstornado,
                    callback: function($$v) {
                      _vm.indEstornado = $$v
                    },
                    expression: "indEstornado"
                  }
                })
              ],
              1
            )
          ]),
          _c("br")
        ]
      ),
      _c("g-fab", { attrs: { ajudas: _vm.ajudaOperacoes } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }